import React, { useState } from "react"
import { stack as Menu } from "react-burger-menu"
import { Link } from "gatsby"
import locations from "../data/locations"

const links = [
	{ path: "/", name: "Home" },
	{ path: "/menu", name: "Menu" },
	{ path: "/gallery", name: "Gallery" },
	...locations.map(location => ({
		path: location.orderOnlineUrl,
		name: `Order Online (${location.name})`,
	})),
]

const socialLinks = [
  { path: "https://www.facebook.com/sitlosaigon/", name: "Facebook" },
  { path: "https://www.yelp.com/biz/sit-lo-saigon-elk-grove", name: "Yelp" },
  { path: "https://www.instagram.com/sitlosaigon/", name: "Instagram" },
]

const MobileNav = () => {
  return (
    <nav className="mobile-navigation" aria-label="Mobile Navigation">
      <Menu>
        {links.map((link, index) => (
          link.path.startsWith('http') ? (
            <a
              className="menu-item"
              href={link.path}
              target="_blank"
              rel="noopener noreferrer"
              key={index}
            >
              {link.name}
            </a>
          ) : (
            <Link
              activeStyle={{ color: "#4A4449" }}
              className="menu-item"
              to={link.path}
              key={index}
            >
              {link.name}
              </Link>
              )
              ))}
              <h2 className="mobile-nav-heading">Connect with us</h2>
              {socialLinks.map((link, index) => (
          <a
            href={link.path}
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            key={index}
          >
            {link.name}
          </a>
        ))}
      </Menu>
    </nav>
  )
}

export default MobileNav
